import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { RequestService } from 'src/app/services/request/request.service';
import Swal from 'sweetalert2';
import { ModalController } from '@ionic/angular';
import { SocialInteractionNotificationService } from 'src/app/services/notifications/social-interaction-notification.service';

@Component({
  selector: 'app-Confirmacion',
  templateUrl: './Confirmacion.html',
  styleUrls: ['./Confirmacion.scss'],
})
export class Confirmacion implements OnInit {
  @Input() email: any;
  @Input() id: number;
  remainingTime: number;
//Confirmación original
public token: string;
  private countdownInterval: any;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private request: RequestService,
    private modalcontroller: ModalController,
    private socialNotifications: SocialInteractionNotificationService,
  ) { }

  ngOnInit() {
    this.startCountdown();
  
  }
  ngOnDestroy() {
    this.stopCountdown();
  }

  startCountdown() {
    this.remainingTime = 60; //299= 4 minutes and 59 seconds

    this.countdownInterval = setInterval(() => {
      this.remainingTime--;

      if (this.remainingTime <= 0) {
        // Stop the countdown when the remaining time reaches zero or below
        this.stopCountdown();
        // Perform any necessary actions when the countdown completes
        // For example, show a message to the user indicating the timeout
      }
    }, 1000);
  }

  stopCountdown() {
    clearInterval(this.countdownInterval);
  }
  formatTime(time: number): string {
    const minutes = Math.floor(time / 60).toString().padStart(2, '0');
    const seconds = (time % 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
  }
  updateToken(event: any) {
    this.token = event.target.value;
  }
  confirmEmail() {
    Swal.fire({
      title: 'Procesando...',
      text: 'La confirmación se está procesando.',
      icon: 'success',
      timer: 3600, // Show the alert for 3 seconds
      timerProgressBar: true,
      toast: true,
      position: 'top-end',
      showConfirmButton: false
    });
    console.log('tok', this.token);
    console.log('profile_id', this.id);
    if (this.token) {
      
      this.request.createRequestPost(`verified-confirmation`, {token: this.token, profile_id: this.id})
      .then(response => {
        console.log('response', response);
      let responseData = response ;
     if (typeof response === 'string') {
     responseData = JSON.parse(response);
     }

        console.log('response code', responseData.code);

        if (responseData.code === 200) {
          
           Swal.fire({
      title: 'Estamos creando tu verificación...',
      text: 'Token correcto',
      icon: 'success',
      timer: 3600, // Show the alert for 3 seconds
      timerProgressBar: true,
      toast: true,
      position: 'top-end',
      showConfirmButton: false
    });
          console.log('Token is correct, proceeding with wallet init');
            // Token is correct, proceed with fund transfer
            let VerificationData = {
              id: this.id,

              // Prepare your verification data here
            };

            this.request.createRequestPost('UsuarioVerificado', VerificationData)
              .then((response) => {
                
                    let responseData = response ;
                      if (typeof response === 'string') {
                      responseData = JSON.parse(response);
                      }
                     if (responseData.code === 200) {
                  this.socialNotifications.notifyLocal(
                    'Correo verificado',
                    `Tu correo ${this.email} fue verificado correctamente.`,
                    { event_type: 'email_verified' },
                  );
                  // Verification update was successful
                  Swal.fire({
                    title: 'Correo confirmado',
                    text: Number(responseData.profile_status_id) === 10
                      ? 'Tu correo está confirmado y Premium está activo.'
                      : 'Tu correo está confirmado. Continúa con la activación de Premium.',
                    icon: 'success',
                    confirmButtonText: 'Understood',
                    color: '#ffffff',
                    background: '#010f4e',
                  }).then(() => {
                    console.log("Alert displayed successfully.");
                  }).catch((error) => {
                    console.error("Error displaying alert:", error);
                  });
                  // Tell the parent that the persisted profile status has
                  // changed. The parent immediately fetches that status and
                  // advances PagoVerificacion without a page reload.
                  this.dismiss({ verified: true, profile_status_id: responseData.profile_status_id });
                } else {
                  // Verifaction failed
                  // Handle failure here (e.g., show an error message to the user)
                  Swal.fire({
                    title: 'Lo siento la verificación falló ',
                    text: `El correo ${this.email}, no ha sido verificado exitosamente.`,
                    icon: 'error',
                    confirmButtonText: 'Understood',
                    color: '#ffffff',
                    background: '#010f4e',
                  }).then(() => {
                    console.log("Alert displayed successfully.");
                  }).catch((error) => {
                    console.error("Error displaying alert:", error);
                  });
                }
              })
              .catch((error) => {
                // Handle network errors or other unexpected errors here
              });
          } else {
            // Token is incorrect
            Swal.fire({
              title: 'The token is invalid',
              icon: 'error',
              confirmButtonText: 'OK',
              customClass: {
                confirmButton: 'btn btn-danger'
              },
              buttonsStyling: false,
              background: '#010f4e',
              iconColor: '#ffffff',
              text: response.title
            });
          }
        })
        .catch(error => {
          Swal.fire({
            title: 'Email Confirmation Failed',
            icon: 'error',
            confirmButtonText: 'OK',
            customClass: {
              confirmButton: 'btn btn-danger'
            },
            buttonsStyling: false,
            background: '#010f4e',
            iconColor: '#ffffff',
            text: error.response.title
          });
        });
    }
    
  }
  dismiss(data?: { verified?: boolean; profile_status_id?: number }){
    this.modalcontroller.dismiss(data)
  }
}
